import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, MinLengthValidator, Validators } from '@angular/forms';
import { ComponentContext } from 'src/app/modules/modal/modal.model';

@Component({
  selector: 'gcc-survey-positive-modal',
  templateUrl: './survey-positive-modal.component.html',
  styleUrls: ['./survey-positive-modal.component.scss']
})
export class SurveyPositiveModal implements ComponentContext<any> {
  @Input() public id: number;
  @Input() public questionTitle: string;
  @Input() public onAction: (value: any) => void;
  @Input() public onClose: () => void;
  private value = {
    surveyBuilderQuestionId: -1,
    isPositive: true,
    answerText: null,
    isCompleted: true
  };
  form: FormGroup = new FormGroup({
    text: new FormControl('', [Validators.maxLength(300)])
  });

  public onCloseSurvey(): void {
    this.onAction({
      ...this.value,
      surveyBuilderQuestionId: this.id,
      answerText: '',
      isCompleted: false
    });
    this.onClose();
  }

  public onSubmit(): void {
    this.onAction({
      ...this.value,
      surveyBuilderQuestionId: this.id,
      answerText: this.form.value.text
    });
    this.onClose();
  }
}
